export default __webpack_public_path__ + "static/media/arrow.278ef945.png";